'use client';

var translations = {
    New: 'Mới',
    'Login to view salary': 'Đăng nhập để xem lương',
    Posted: 'Đã đăng',
    'Expires: ': 'Hết hạn: ',
    in: 'trong',
    'Expires on today': 'Hết hạn trong hôm nay',
    day: 'ngày',
    s: '',
    Bonus: 'Thưởng',
    'Healthcare Plan': 'Khám sức khỏe',
    'Paid Leave': 'Nghỉ phép',
    Training: 'Đào tạo',
    Awards: 'Giải thưởng',
    Library: 'Thư viện',
    Laptop: 'Laptop',
    Mobile: 'Điện thoại',
    'Travel Opportunities': 'Du lịch',
    'Team Activities': 'Hoạt động',
    Transportation: 'Trợ cấp đi lại',
    Canteen: 'Căn-tin',
    Vouchers: 'Thưởng quà',
    Kindergarten: 'Trông trẻ',
    Others: 'Khác',
    Applied: 'Đã nộp đơn',
    'You should': 'Bạn phải',
    'Sign In': 'đăng nhập',
    'to save jobs': 'để lưu công việc',
    'Save job successfully': 'Lưu công việc thành công',
    'Remove job successfully': 'Xóa công việc thành công',
    Updated: 'Cập nhật',
    Today: 'Hôm nay',
    'Posted 3 days ago': 'Cập nhật cách đây 3 ngày',
    'Posted on': 'Đăng ngày',
    'You have': 'Bạn còn',
    'days to apply': 'ngày để ứng tuyển',
    'day to apply': 'ngày để ứng tuyển',
    Expire: 'Hết hạn',
    'TODAY!': 'HÔM NAY!',
    'Latest ': '',
    'employment/hiring with high salary & attractive benefits': 'tuyển dụng - Tìm việc mới nhất, lương thưởng hấp dẫn.',
    '/job-channel/top-management': '/kenh-viec-lam/quan-ly',
    '/management-jobs': '/viec-lam-quan-ly',
    Featured: 'Tiêu biểu',
    Matching: 'Phù Hợp',
    'This job is consistent with the following criteria in your profile: Title, Skills, Workplace, Category.': 'Việc làm này phù hợp với các tiêu chí sau trong hồ sơ của bạn: Chức danh, Kỹ năng, Địa điểm làm việc, Ngành nghề.',
    'Information of this employer is hidden for confidentiality purposes.': 'Thông tin nhà tuyển dụng đã được ẩn đi vì mục đích bảo mật.',
    'Trusted company': 'Công ty uy tín',
    'Job hidden': 'Đã ẩn việc làm',
    'You will not see this job on the search page.': 'Bạn sẽ không nhìn thấy việc làm này trên trang tìm kiếm.',
    Success: 'Thành công',
    'Just removed 1 save job': 'Bạn vừa xóa 1 công việc',
    'You have saved job, view': 'Bạn đã lưu việc làm thành công, xem ',
    'My jobs': 'Việc làm của tôi',
    '/my-career-center/my-jobs?section=saved': '/quan-ly-nghe-nghiep/viec-lam-cua-toi?section=saved',
    'Employer highly values your resume and has sent you an invitation to apply.': 'Nhà tuyển dụng đánh giá cao hồ sơ của bạn và đã gửi lời mời ứng tuyển.',
    'AI summary': 'AI tóm tắt'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
